import React from 'react'
import { Spinner } from './styles/Loading.style'

const Loading = () => {
  return <Spinner>Carregando...</Spinner>
}

export default Loading
